import type { UserRepository } from '#/domain/user/UserRepository'

export class RemoveRolesUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, roles: string[], organizationId?: string): Promise<void> {
    return this.repository.removeRoles(userId, roles, organizationId)
  }
}
